module.exports = __webpack_public_path__ + "media/images/press_kit/virgin_voyages/email/top-light-small-bd62fa8fd774ff8faa3c39082d55b767.png";